<script setup lang="ts">
import AppShell from "../Layout/AppShell.vue"
import ProductionOrderForm from "./components/ProductionOrderForm.vue"

defineProps<{
  production_order: {
    id?: number | null
    company_id: number | ""
    expected_at: string
    items: Array<{
      id?: number | null
      product_id: number | ""
      quantity: string
    }>
  }
  products: Array<{ label: string; value: number }>
  errors?: Record<string, string[]>
}>()
</script>

<template>
  <AppShell>
    <ProductionOrderForm
      mode="create"
      title="Nova ordem de producao"
      subtitle="Planeje itens de producao e valide viabilidade de materiais antes de concluir."
      :production-order="production_order"
      :products="products"
      :errors="errors"
    />
  </AppShell>
</template>

